import { isServer } from '@vue-storefront/core/helpers'
import config from 'config';

export default {
  computed: {
    getRootCategorySlug () {
      // console.log(this.$route);
      // let category = this.$store.getters['category/getCurrentCategory'];
      // console.log(typeof category.path);
      // console.log(this.$route);
      // console.log(this.$route.params.catalog);
      let category = this.$store.state.category.current;
      if (this.$route.fullPath === '/') {
        if (typeof this.$route.meta.category !== 'undefined' && this.$route.meta.category !== '') {
          return this.$route.meta.category;
        }
        return null;
      } else if (typeof category.path !== 'undefined') {
        let categoryPathArray = category.path.split('/');
        if (categoryPathArray.length) {
          if (categoryPathArray[0] === config.rootcategories.biuro) {
            return config.rootcategories.biuro
          } else {
            let __tmp = categoryPathArray[0].split('-');
            if (__tmp.length > 0) {
              return __tmp[__tmp.length - 1];
            }
          }
        }
      } else if (typeof this.$route.meta.url_key !== 'undefined' && this.$route.meta.url_key !== '') {
        let __tmp = this.$route.meta.url_key.split('-');
        if (__tmp.length > 0) {
          return __tmp[__tmp.length - 1];
        }
      } else if (typeof this.$route.params.catalog !== 'undefined' && this.$route.params.catalog !== '') {
        return this.$route.params.catalog;
      } else if (this.$route.name === 'cms-page' || this.$route.name === 'page-not-found' || this.$route.name === 'category') {
        if (!isServer) {
          if (window.location.pathname.startsWith(config.site.office_path)) {
            return config.rootcategories.biuro
          } else {
            return config.rootcategories.drukowanie
          }
        }
      }
      return null;
    }
  }
}
